import axios from "axios";
import { setCurrentUser } from "utils/utils";
import { API_ENDPOINT } from "./Api"

const payUtestUrl =  process.env.REACT_APP_API_BASE_URL;
const domainUrl = process.env.REACT_APP_DOMAIN_BASE_URL
const requestInstance = axios.create({
    baseURL: payUtestUrl,
    headers:{
        "Content-Type": 'application/x-www-form-urlencoded',
    }
  });

export const payUApi = async (data) =>{
    const res = await requestInstance
    .post(`${payUtestUrl}${API_ENDPOINT.PayU.api}`, data)
    .catch((err) => err.response);
    return setCurrentUser(res);
   
}

export const payuResponseApi = async () => {
    const res = await requestInstance
    .post(`${domainUrl}${API_ENDPOINT.PayU.payuResponse}`)
    .catch((err) => err.response);
    return setCurrentUser(res);
}